export default function MajorIcon() {
  return (
    <svg
      data-testid="MajorIcon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3982 7.39825C12.7872 7.00925 12.7872 6.373 12.3982 5.984L8.706 2.29175C8.317 1.90275 7.68075 1.90275 7.29175 2.29175C6.90275 2.68075 6.90275 3.317 7.29175 3.706L10.984 7.39825C11.3728 7.787 12.0092 7.787 12.3982 7.39825Z"
        fill="#FFC107"
      />
      <path
        d="M3.56009 7.39825C3.17109 7.00925 3.17109 6.373 3.56009 5.984L7.25234 2.29175C7.64134 1.90275 8.27759 1.90275 8.66659 2.29175C9.05559 2.68075 9.05559 3.317 8.66659 3.706L4.97409 7.39825C4.58534 7.787 3.94884 7.787 3.56009 7.39825Z"
        fill="#FFC107"
      />
      <path
        d="M12.3982 12.389C12.7872 12 12.7872 11.3637 12.3982 10.9747L8.706 7.28247C8.317 6.89347 7.68075 6.89347 7.29175 7.28247C6.90275 7.67147 6.90275 8.30772 7.29175 8.69672L10.984 12.389C11.3728 12.7777 12.0092 12.7777 12.3982 12.389Z"
        fill="#C79100"
      />
      <path
        d="M3.56009 12.389C3.17109 12 3.17109 11.3637 3.56009 10.9747L7.25234 7.28247C7.64134 6.89347 8.27759 6.89347 8.66659 7.28247C9.05559 7.67147 9.05559 8.30772 8.66659 8.69672L4.97409 12.389C4.58534 12.7777 3.94884 12.7777 3.56009 12.389Z"
        fill="#C79100"
      />
    </svg>
  );
}
